export default __webpack_public_path__ + "No-Results-Found.210f67df6a8a980263070d9d217007d6.svg";